// @flow
import { connect } from "react-redux"
import type { Connector } from "react-redux"

import HeaderDataSideEffects from "common/browser/components/HeaderDataSideEffects"
import type { Props } from "common/browser/components/HeaderDataSideEffects"
import * as selectors from "common/browser/headerDataSelectors"

const connector: Connector<{}, Props> = connect(state => ({
  title: selectors.getTitle(state),
  keywords: selectors.getKeywords(state),
  description: selectors.getDescription(state),
}))

export default connector(HeaderDataSideEffects)
